import { render } from "./OmnyUILayout.vue?vue&type=template&id=014c12e0&scoped=true"
import script from "./OmnyUILayout.vue?vue&type=script&lang=js"
export * from "./OmnyUILayout.vue?vue&type=script&lang=js"

import "./OmnyUILayout.vue?vue&type=style&index=0&id=014c12e0&lang=scss"
import "./OmnyUILayout.vue?vue&type=style&index=1&id=014c12e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014c12e0"]])

export default __exports__